import React from 'react';
import { ArrowRight, MapPin, Mail, Linkedin } from 'lucide-react';
import { Button } from './ui/button';
import { personalInfo } from '../mock';

const Hero = ({ isVisible }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      data-section
      className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-white overflow-hidden pt-20"
    >
      {/* Decorative background elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
      <div className="absolute bottom-20 left-10 w-72 h-72 bg-blue-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>

      <div className="container mx-auto px-6 py-20 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div
            className={`transition-all duration-1000 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <h1 className="text-5xl md:text-7xl font-bold text-blue-900 mb-6">
              {personalInfo.name}
            </h1>
            <p className="text-2xl md:text-3xl text-blue-700 font-semibold mb-4">
              {personalInfo.title}
            </p>
            <p className="text-lg md:text-xl text-slate-600 mb-8 max-w-2xl mx-auto">
              {personalInfo.tagline}
            </p>

            <div className="flex flex-wrap items-center justify-center gap-4 mb-12 text-slate-600">
              <div className="flex items-center gap-2">
                <MapPin size={18} className="text-blue-700" />
                <span>{personalInfo.location}</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail size={18} className="text-blue-700" />
                <a
                  href={`mailto:${personalInfo.email}`}
                  className="hover:text-blue-700 transition-colors"
                >
                  {personalInfo.email}
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Linkedin size={18} className="text-blue-700" />
                <a
                  href={`https://${personalInfo.linkedin}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-blue-700 transition-colors"
                >
                  LinkedIn
                </a>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                onClick={() => scrollToSection('projects')}
                size="lg"
                className="bg-blue-700 hover:bg-blue-800 text-white text-lg px-8 py-6 transform hover:scale-105 transition-transform"
              >
                View My Work
                <ArrowRight className="ml-2" size={20} />
              </Button>
              <Button
                onClick={() => scrollToSection('contact')}
                size="lg"
                variant="outline"
                className="border-2 border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white text-lg px-8 py-6 transform hover:scale-105 transition-transform"
              >
                Contact Me
              </Button>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes blob {
          0% {
            transform: translate(0px, 0px) scale(1);
          }
          33% {
            transform: translate(30px, -50px) scale(1.1);
          }
          66% {
            transform: translate(-20px, 20px) scale(0.9);
          }
          100% {
            transform: translate(0px, 0px) scale(1);
          }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
      `}</style>
    </section>
  );
};

export default Hero;